import { AppointmentID } from "./Appointment";
import { CarID } from "./Car";
import { Checklist, ChecklistID } from "./Checklist";
import { InterventionID } from "./Intervention";
import { QuestionResult } from "./QuestionResult";
import { User, UserID } from "./User";

export type CarCheckID = number;

export enum DBB_STATUSES {
  NoDBBStatus = 0,
  DBBPushed = 1,
  DBBIsPending = 2,
  DBBFailed = 3
}

export interface CarCheck {
  created_on: string;
  updated_on: string;
  id: CarCheckID; // Claire CarCheck ID
  version: string; // Version of the check, incremented on every update
  duration: number; // Check duration in seconds
  appointment_id: AppointmentID; // Claire appointment ID
  mechanic_id: UserID; // User ID of the mechanic who performed the check
  receptionist_id: UserID | null; // User ID of the receptionist assigned to this check
  checklist_id: ChecklistID; // Checklist ID used for this check
  purpose: string; // Purpose of the check
  dbb_status: DBB_STATUSES; // Status of pushing the check to DBB
  dbb_status_reason: string; // Reason given by DBB for the status
  car_id: CarID; // Unique ID of the Car this check was performed on
  intervention_id: InterventionID | null; // If provided, link the intervention for which this car check was done
  current_km: number | null; // An optional current mileage if entered at the beginning of the check, stored in the check in case it failed to write back to the DMS
  next_km: number | null; // An optional next mileage if entered at the beginning of the check, stored in the check in case it failed to write back to the DMS
  next_date: string | null; // An optional next date if entered at the beginning of the check, stored in the check in case it failed to write back to the DMS
  mechanic?: User; // User object of the mechanic who performed the check, refer to that model for more detail
  checklist?: Checklist; // Checklist object for this check, refer to that model for more details
  receptionist?: User; // User object of the receptionist assigned to this check, refer to that model for more detail
  question_items?: QuestionResult[]; // Array of QuestionResult object, containing the result of this check, refer to that model for more detail
}
